import React from "react";
import {CToast, CToastBody, CToaster, CToastHeader} from "@coreui/react";
import {useDispatch, useSelector} from "react-redux";
import logo from '../assets/images/logoMaestros.png';

const defaultAlertId = "defaultAlertId";

const classesType = {
  success: "colorSuccess",
  warning: "colorWarning",
  error: "colorError"
}

const Alert = ({id = defaultAlertId}) => {

  const dispatch = useDispatch();
  const alertState = useSelector(state => state.alert);

  const onChangeStateAlert = (state) => {
    if(!state) {
      dispatch({type: "setStateAlert", alert: null})
    }
  }

  if(!(alertState?.message)){
      return null;
  }

  return(
    <CToaster title="Mensaje de soporte" className="mr-5 mb-4" style={{zIndex: 99999}} position="bottom-right">
      <CToast show={true} className={classesType[alertState?.type]}
              title="Mensaje de soporte"
              onStateChange={(state) => onChangeStateAlert(state)}
              autohide={3000}
              >
        <CToastHeader closeButton={true} className="d-flex justify-content-between align-items-center w-100">
          <img src={logo} style={{width:20, height:20}} className="rounded mr-2" alt="..." />
          <strong className="me-auto">Mensaje de soporte</strong>
          <small className="px-2">ahora</small>
        </CToastHeader>
        <CToastBody>{alertState?.message}</CToastBody>
      </CToast>
    </CToaster>
  )

}


export default Alert;
